export enum NativeUCAppType {
    Sport888 = 'Sport888',
}

export const TimeLimitErrorCodes = {
    dailyTimeLimit: 601,
    weeklyTimeLimit: 602,
    monthlyTimeLimit: 603,
    yearlyTimeLimit: 604,
    standardTimeLimit: 605,
    realSpendingLimitExceeded: 699,
};
